var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Badge, Select } from "@bolteu/kalep-react";
import { Filter, FilterOutlined } from "@bolteu/kalep-react-icons";
import { cx } from "../utils/cx";
export function ColumnFilter({ columnKey, filter, width, onFilterChange }) {
    const [selectedOption, setSelectedOption] = React.useState(filter.selectionMode === "multiple" ? [] : null);
    const isOptionEqualToValue = React.useCallback((option, value) => option.value === (value === null || value === void 0 ? void 0 : value.value), []);
    const handleChange = React.useCallback((option) => {
        let value;
        if (filter.selectionMode === "multiple") {
            value = option;
        }
        else if (isOptionEqualToValue(option, selectedOption)) {
            value = null;
        }
        else {
            value = option;
        }
        setSelectedOption(value);
        onFilterChange === null || onFilterChange === void 0 ? void 0 : onFilterChange(columnKey, unwrapSelectedOption(value));
    }, [selectedOption, setSelectedOption, filter, isOptionEqualToValue, columnKey, onFilterChange]);
    const handlePointerDown = React.useCallback((event) => {
        // Prevents event propagation to avoid triggering re-sort on the table header cell
        event.stopPropagation();
    }, []);
    const renderTrigger = React.useCallback(
    // @todo: this typing is wrong.
    // Correct would be something like: SelectProps & UseSelectGetToggleButtonReturnValue
    // But it's not possible to import UseSelectGetToggleButtonReturnValue from kalep-react, because it's coming from downshift
    function renderTrigger(_a) {
        var { ref, disabled, ariaDescribedby } = _a, rest = __rest(_a, ["ref", "disabled", "ariaDescribedby"]);
        const hasSelection = filter.selectionMode === "multiple"
            ? (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.length) > 0
            : !!selectedOption;
        return (React.createElement("button", Object.assign({ ref: ref, type: "button", disabled: disabled, "aria-label": "Filter", "aria-describedby": ariaDescribedby, className: cx("border-none outline-none bg-transparent flex items-center") }, rest, { onPointerDown: handlePointerDown }), hasSelection ? (React.createElement(Badge, { variant: "s-dot", appearance: "action" },
            React.createElement(Filter, { size: "md", className: cx("text-primary") }))) : (React.createElement(FilterOutlined, { size: "md", className: cx("text-primary") }))));
    }, [selectedOption, filter.selectionMode, handlePointerDown]);
    return (React.createElement("div", null,
        React.createElement(Select, { value: selectedOption, multiple: filter.selectionMode === "multiple", onChange: handleChange, options: filter.options, isOptionEqualToValue: isOptionEqualToValue, size: "sm", fullWidth: true, overlayConfig: { minWidth: width, position: { offset: 12, crossOffset: 10, placement: "bottom right" } }, clearable: false, renderTrigger: renderTrigger })));
}
function unwrapSelectedOption(option) {
    if (option === null) {
        return null;
    }
    if (Array.isArray(option)) {
        return option.map((o) => o.value);
    }
    return option.value;
}
